import * as React from "react";
import { connect } from 'react-redux';
import { Typography } from "@material-ui/core";
import Button from "@components/common/button/Button";
import Dialog from "@components/common/dialog/dialog.component";
import TranslateNew from "@translate/TranslateNew";
import { closeAlreadyLoggedInNotice } from '@services/accountLink/accountLink.actions';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps {
  open: boolean;
  close: () => void;
}

// Shown over Settings instead of acting on an account link while someone is
// logged in. It sits outside the routes so the redirects that follow a link
// cannot dismiss it.
export class AlreadyLoggedInDialogComponent extends React.Component<IProps> {
  public render() {
    const { open, close } = this.props;

    return (<Dialog
      open={open}
      onClose={close}
      title={tn.lang.alreadyLoggedInTitle}
      content={<Typography variant="body1">{tn.lang.alreadyLoggedInLinkBody}</Typography>}
      actions={<Button
        color="primary"
        variant="contained"
        size="large"
        autoFocus={true}
        fullWidth={true}
        onClick={close}
      >
        {tn.lang.close}
      </Button>}
    />);
  }
}

function mapStateToProps(state: any) {
  return {
    open: !!state.accountLink?.alreadyLoggedInNoticeOpen,
  };
}

export default connect(mapStateToProps, { close: closeAlreadyLoggedInNotice })(AlreadyLoggedInDialogComponent);



// WEBPACK FOOTER //
// ./src/components/common/alreadyLoggedIn/AlreadyLoggedInDialog.tsx